import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LoginService } from 'src/app/services/login.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/services/sharedDataService.service';

interface FeatureSlide {
    title: string;
    subtitle: string;
    points: { name: string; subTexts: string[], imageUrl: string }[];
}

@Component({
    selector: 'app-new-feature-guide',
    templateUrl: './new-feature-guide.component.html',
    styleUrls: ['./new-feature-guide.component.less']
})
export class NewFeatureGuideComponent implements OnInit {
    @Output() guideCompleted = new EventEmitter<void>();

    isVisible: boolean = false;
    dontShowForSevenDays: boolean = false;
    environment = environment;
    newContentArray: any[] = [];
    isDealerPortal: boolean = false;

    constructor(
        private loginService: LoginService,
        private router: Router,
        private sharedData: SharedDataService
    ) {
        this.sharedData.currentData.subscribe(data => {
            this.isDealerPortal = data.isDealerPortal;
        });
    }

    // 轮播数据源（增加至3条以便完美演示 3D 层叠效果）
    slides: any[] = [
        // {
        //     badge: '新功能上线',
        //     title: '采购与返利数据一目了然',
        //     subtitle: '快速了解您的目标进度与返利情况',
        //     points: [
        //         { name: '年度采购目标总览', subTexts: ['实时查看年度目标与完成进度'], imageUrl: 'assets/official-website/banner1.JPG' },
        //         { name: '产品线目标与返利进度', subTexts: ['按产品线掌握完成率与返利金额'], imageUrl: 'assets/official-website/banner2.JPG' },
        //         { name: '返利金额状态追踪', subTexts: ['清晰区分目标、已发放与已使用返利'], imageUrl: 'assets/official-website/banner4.JPG' }
        //     ],
        //     newProductImage: '',
        //     navigationUrl: '/contracts_rebates',
        //     highlightModule: '采购目标达成',
        //     visibleInSevenDays: 'true',
        //     type: 'NEW_FEATURE',
        // },
        // {
        //     badge: '产品上新',
        //     title: '两轮锂电池',
        //     subtitle: '面向高性能骑行与竞赛场景的启动锂电池',
        //     points: [
        //         { name: '强劲启动+轻量化', subTexts: ['5s瞬间爆发， 30s持续启动', '重量比传统铅酸电池轻约2/3'], imageUrl: '' },
        //         { name: '极寒依然稳定', subTexts: ['低温环境下循环100次'], imageUrl: '' }
        //     ],
        //     newProductImage: 'assets/official-website/banner4.JPG',
        //     navigationUrl: 'product/detail?articleNumber=3397013881&partId=436',
        //     highlightModule: '',
        //     visibleInSevenDays: 'true',
        //     type: 'NEW_PRODUCT',
        // },
        // {
        //     badge: '产品上新',
        //     title: '智能报表中心上线',
        //     subtitle: '多维度数据分析，助力业务高效决策',
        //     points: [
        //         { name: '自定义数据看板', subTexts: ['灵活配置您关注的核心业务指标'], imageUrl: 'assets/official-website/banner4.JPG' },
        //         { name: '一键导出与分享', subTexts: ['支持多种格式导出，团队协作更方便'], imageUrl: 'assets/official-website/banner5.JPG' }
        //     ],
        //     newProductImage: '',
        //     navigationUrl: 'gb/cn/parts',
        //     highlightModule: '采购目标达成',
        //     visibleInSevenDays: 'true',
        //     type: 'NEW_FEATURE',
        // }
    ];

    currentIndex: number = 0;
    // 为每个卡片维护一个内部轮播索引
    subIndices: number[] = [];
    // 图片加载状态追踪
    imageLoadedMap: { [url: string]: boolean } = {};
    private timer: any;
    private slideTimer: any;
    private cardSwitchInterval: number = 10000;
    private hasEmittedCompletion: boolean = false;

    // 初始化逻辑保持不变
    ngOnInit(): void {
        this.getValidPopupWindows();
        // 初始化每个 slide 的内部高亮索引为 0
    }

    startInternalTimer() {
        this.timer = setInterval(() => {
            const currentSlide = this.slides[this.currentIndex];
            if (currentSlide && currentSlide.points && currentSlide.points.length > 0) {
                this.subIndices[this.currentIndex] = (this.subIndices[this.currentIndex] + 1) % currentSlide.points.length;
            }
        }, 3000);

        this.slideTimer = setInterval(() => {
            this.nextSlide();
        }, this.cardSwitchInterval);
    }

    ngOnDestroy() {
        if (this.timer) clearInterval(this.timer);
        if (this.slideTimer) clearInterval(this.slideTimer);
    }

    getValidPopupWindows() {
        console.log('environment.userCenterAdminUrl', environment.userCenterAdminUrl)
        this.loginService.getValidPopupWindows().subscribe(result => {
            const { rtnData } = result;
            if (rtnData !== undefined && rtnData !== null) {
                const newContentArray = rtnData.map((item: any) => {
                    const { content } = item; // 提取 content 对象
                    const baseUrl = `${environment.userCenterAdminUrl}/file/download/`;
                    return {
                        ...content, // 展开 content 原有属性
                        // 1. 修改 navigationUrl
                        newProductImage: content.newProductImage
                            ? `${baseUrl}${content.newProductImage}`
                            : content.newProductImage,

                        // 2. 遍历并修改 points 数组中的 imageUrl
                        points: content.points.map((point: any) => ({
                            ...point, // 展开 point 原有属性
                            imageUrl: point.imageUrl
                                ? `${baseUrl}${point.imageUrl}`
                                : point.imageUrl
                        }))
                    };
                });
                this.checkModalVisibility();
                this.slides = newContentArray;
                this.subIndices = this.slides.map(() => 0);
                if (this.slides.length > 0) {
                    this.startInternalTimer();
                } else {
                    this.emitGuideCompleted();
                }
            } else {
                this.emitGuideCompleted();
            }
        });
    }

    checkModalVisibility(): void {
        const hideFlag = this.getCookie('hideFeatureModal');
        if (!hideFlag) {
            this.dontShowForSevenDays = false;
            this.isVisible = true;
            return;
        }
        this.emitGuideCompleted();
    }

    // 根据索引计算当前卡片应处于的位置（左、中、右、隐藏）
    getCardClass(index: number): string {
        const length = this.slides.length;
        if (index === this.currentIndex) {
            return 'card-center';
        }
        if (index === (this.currentIndex - 1 + length) % length) {
            return 'card-left';
        }
        if (index === (this.currentIndex + 1) % length) {
            return 'card-right';
        }
        return 'card-hidden';
    }

    // 点击切换卡片
    goToSlide(index: number): void {
        this.currentIndex = index;
    }

    onCheck(navigationUrl: string): void {
        window.open(navigationUrl, '_blank');
        this.closeModal();
        if (environment.production) {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const customer = JSON.parse(localStorage.getItem('customer') || '{}');
            (window as any).dataLayer.push({
                event: 'dp_welcome_page_click',
                from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                event_type: 'view',
                event_name: '',
                portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
                event_content: '',
            });
        }
    }

    closeModal(): void {
        this.isVisible = false;
        this.emitGuideCompleted();
        if (environment.production) {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const customer = JSON.parse(localStorage.getItem('customer') || '{}');
            (window as any).dataLayer.push({
                event: 'dp_welcome_page_click',
                from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                event_type: 'close',
                event_name: '',
                portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
                event_content: '',
            });
        }
    }

    hideModal() {
        if (this.dontShowForSevenDays) {
            this.setCookie('hideFeatureModal', 'true', 7);
        }
        this.isVisible = false;
        this.emitGuideCompleted();
        if (environment.production) {
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const customer = JSON.parse(localStorage.getItem('customer') || '{}');
            (window as any).dataLayer.push({
                event: 'dp_welcome_page_click',
                from_page: (localStorage.getItem('token') ? 'afterLogin ' : 'beforeLogin ') + window.location.pathname,
                event_type: 'hide',
                event_name: '',
                portal_name: this.isDealerPortal ? "DealerPortal " + customer?.customerCode : "SalesPortal " + userData?.queryUserPageInfoResDTO?.ntAccount,
                event_content: '',
            });
        }
    }

    /** 设置 Cookie，days 为过期天数 */
    private setCookie(name: string, value: string, days: number): void {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`;
    }

    /** 读取 Cookie */
    private getCookie(name: string): string | null {
        const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    }

    onImageLoad(url: string): void {
        this.imageLoadedMap[url] = true;
    }

    isImageLoaded(url: string): boolean {
        return !!this.imageLoadedMap[url];
    }

    // 添加在 goToSlide 方法下方
    prevSlide(): void {
        this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    }

    nextSlide(): void {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }

    private emitGuideCompleted(): void {
        if (this.hasEmittedCompletion) {
            return;
        }
        this.hasEmittedCompletion = true;
        this.guideCompleted.emit();
    }
}
